import { parse } from "query-string";
import React from "react";
import { setArtistCookie } from "../data/page_data";

export default class EntryPage extends React.Component {
  artistId = [
    {
      id: 9,
      name: "erick",
    },
    {
      id: 5,
      name: "inul",
    },
    {
      id: 15,
      name: "judika",
    },
    {
      id: 14,
      name: "justin",
    },
    {
      id: 16,
      name: "marsha",
    },
    {
      id: 7,
      name: "putdel",
    },
    {
      id: 3,
      name: "rizky",
    },
    {
      id: 13,
      name: "tissa",
    },
    {
      id: 4,
      name: "tulus",
    },
    {
      id: 10,
      name: "vebby",
    },
    {
      id: 6,
      name: "wali",
    },
    {
      id: 2,
      name: "wilona",
    },
  ];
  constructor(props) {
    super(props);

    this.params = parse(this.props.location.search);
  }
  componentDidMount() {
    var name = this.props.artist;

    if (this.props.artist === "all") {
      this.artistId.forEach((value) => {
        if (this.params.aid === String(value.id)) {
          name = value.name;
        }
      });
    }

    setArtistCookie(this.props.artist, this.params.value);

    // Entry is an authentication boundary. Load the destination as a fresh
    // document so the target page always starts after the auth cookie exists.
    // SPA navigation could update the URL while leaving this blank component
    // mounted until the user manually refreshed the page.
    window.location.replace(
      "/w/" + encodeURIComponent(name) + "/" + this.params.go
    );
  }

  render() {
    return <></>;
  }
}
